import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import AnswersList from './AnswersList';
import LocPageFooter from './PageFooter';

function LocAnswersCornell() {
  // <BuildBootStrapMenu />
  const parkingType = (
    <ul style={{ marginBottom: 1 }}>
      <li>
        Daytime Commuter: 24 hour / 7 day access. Must exit after work shift
        ends.
      </li>
      <li>
        Nights & Weekends Commuter: Entry M–F after 2:30 p.m. on weekdays. On
        weekends and observed NYP holidays.
      </li>
      <li>
        Storage Parking: Storage parking is only available to employees who
        reside in NYP Housing buildings.
      </li>
    </ul>
  );

  const waitingList =
    'For day commuter parking, yes. No waiting list for night shift commuters';

  const campusName = 'Weill Cornell Campus';
  const campusContact = 'parkingnyp-east@nyp.org';
  const carStorage =
    'Yes. Storage parking is only available to employees ' +
    'who reside in NYP Housing buildings.';
  const telNum = '212-746-7357';
  const eligible = ' and Cornell College Medical';

  return (
    <div style={{ marginBottom: 20 }}>
      <LocPageFooter
        title="For answers related to NYP Cornell Campus parking locations, 
          please click on the questions below."
      />
      <AnswersList
        parkType={parkingType}
        waitList={waitingList}
        campus={campusName}
        contact={campusContact}
        storage={carStorage}
        tel={telNum}
        eligibleGrp={eligible}
      />
    </div>
  );
}

export default LocAnswersCornell;
